@if (triggerLabel(); as text) {
  <esn-button
    variant="secondary"
    trailingIcon="chevron-down"
    [disabled]="disabled()"
    haspopup="menu"
    [expanded]="open()"
    (clicked)="toggle()"
  >
    {{ text }}
  </esn-button>
} @else {
  <esn-icon-button
    icon="dots"
    [label]="label()"
    [size]="triggerSize()"
    [disabled]="disabled()"
    haspopup="menu"
    [expanded]="open()"
    (clicked)="toggle()"
  />
}
@if (open()) {
  <div
    class="esn-menu"
    [class]="'esn-menu--' + size()"
    role="menu"
    popover="manual"
    [attr.aria-label]="label()"
    [style.width.px]="menuWidth()"
    [style.top.px]="coords().top"
    [style.left.px]="coords().left"
    (keydown)="handleKeydown($event)"
  >
    @for (item of regularItems(); track item.id) {
      <button type="button" class="esn-menu__item" role="menuitem" [disabled]="item.disabled" (click)="choose(item)">
        @if (item.icon) {
          <esn-icon [name]="item.icon" [size]="16" />
        }
        {{ item.label }}
      </button>
    }
    @if (dangerItems().length) {
      @if (regularItems().length) {
        <div class="esn-menu__divider" role="separator"></div>
      }
      <div class="esn-menu__destructive">
        @for (item of dangerItems(); track item.id) {
          <button type="button" class="esn-menu__danger" role="menuitem" [disabled]="item.disabled" (click)="choose(item)">
            @if (item.icon) {
              <esn-icon [name]="item.icon" [size]="16" />
            }
            {{ item.label }}
          </button>
        }
      </div>
    }
  </div>
}
